<template>
  <router-view />
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueSession from 'vue-session'
import Vuetify from 'vuetify'
import VueTour from "vue-tour";

require('vue-tour/dist/vue-tour.css')

Vue.use(Vuetify)
Vue.use(VueAxios, axios)
Vue.use(VueSession)
Vue.use(VueTour)

export default {
  name: 'App'
}
</script>
<style>
/*#quitarborde.v-text-field fieldset, .v-text-field .v-input__control, .v-text-field .v-input__slot {
  border-width: 0 !important;
 
}*/
.v-text-field--filled.v-input--dense.v-text-field--single-line > .v-input__control > .v-input__slot, .v-text-field--filled.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot, .v-text-field--filled.v-input--dense.v-text-field--outlined.v-text-field--filled > .v-input__control > .v-input__slot, .v-text-field--full-width.v-input--dense.v-text-field--single-line > .v-input__control > .v-input__slot, .v-text-field--full-width.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot, .v-text-field--full-width.v-input--dense.v-text-field--outlined.v-text-field--filled > .v-input__control > .v-input__slot, .v-text-field--outlined.v-input--dense.v-text-field--single-line > .v-input__control > .v-input__slot, .v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot, .v-text-field--outlined.v-input--dense.v-text-field--outlined.v-text-field--filled > .v-input__control > .v-input__slot {
    min-height: 36px!important;
    
}


.v-menu__content.menu-square {
border: 2px solid #6366F1 !important;
  box-shadow: none !important; /* opcional */
  border-color: #6366F1 !important;
}

/* El interior del picker también trae radios */
.v-menu__content.menu-square .v-card,
.v-menu__content.menu-square .v-sheet,
.v-menu__content.menu-square .v-picker,
.v-menu__content.menu-square .v-picker__title {
  border-radius: 0 !important;
  border-color: #6366F1 !important;
}
.v-menu__content.menu-square .v-picker__title {
  background: #fff !important;           /* pon el fondo que quieras */
  color: #6366F1 !important;             /* color del texto del título */
  border-radius: 0 !important;
}

/* Por si el tema gana la especificidad */
.theme--light.v-menu__content.menu-square {
  border-radius: 2px !important;
  border-color: #6366F1 !important;
}


canvas {
  height: 100% !important;
  margin-top: 0 !important;
  padding-top: 0 !important;
}
.axi {
  font-family: 'Axiforma', sans-serif !important;
}

.axi-light {
  font-family: 'Axiforma', sans-serif !important;
  font-weight: 300 !important;
}

.axi-regular {
  font-family: 'Axiforma', sans-serif !important;
  font-weight: 400 !important;
}

.axi-medium {
  font-family: 'Axiforma', sans-serif !important;
  font-weight: 500 !important;
}

.axi-bold {
  font-family: 'Axiforma' !important;
  font-weight: 700 !important;
}

.axi-black {
  font-family: 'Axiforma', sans-serif !important;
  font-weight: 900 !important;
}
.axi-tight {
  line-height: 1 !important;
}
.title-section{
  color: #000;
  font-family: Axiforma!important;
  font-size: 2.25rem!important;
  font-style: normal;
  line-height: normal;
}
.title-scope{
  color: #000;

  font-family: Axiforma;
  font-size: 0.875rem;
  font-style: normal;
  line-height: 1.875rem; 
}
.title-vs{
  color: #000;

  font-family: Axiforma!important;
  font-size: 0.625rem;
  font-style: normal;
  line-height: 1.875rem;
}
.title-percentage{
  text-align: right;
  font-size: 0.875rem;
  font-style: normal;
  line-height: 1.875rem;
}
.title-number{
  color: #000;
  font-family: Axiforma!important;
  font-size: 1.5rem;
  font-style: normal;
  line-height: 1.875rem;
}
.title-tco{
  color: #AAA;

  font-family: Axiforma!important;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 400!important;
  line-height: 1.875rem;
}
.title-graph{
  color: #000;
  font-family: Axiforma!important;
  font-size: 1.5rem!important;
  font-style: normal;
  line-height: 3.8125rem;
}
.poppinsFont {
  font-family: 'Poppins', sans-serif;
}
.capitalizar-solo-primera {
  text-transform: none;
  display: inline-block;
}
.capitalizar-solo-primera::first-letter {
  text-transform: uppercase;
}

/* Contenedor del dropdown del autocomplete */
.v-menu__content.location-menu {
  border: 2px solid #6366F1 !important;
  border-radius: 3px !important;
  box-shadow: none !important;   /* quita la sombra de Vuetify si no la quieres */
  overflow: hidden;               /* redondeo también para el interior */
  background: #fff;               /* asegura fondo blanco */
  min-width: 250px;               /* mismo ancho que el activador */
  margin-top: 6px;                /* similar al date picker */
}
.list-design{
  border: 2px solid #6366F1 !important;
  border-radius: 3px !important;
  box-shadow: none !important;  
}

/* Interior sin radios (opcional, para que todo se vea cuadrado) */
.v-menu__content.location-menu .v-card,
.v-menu__content.location-menu .v-sheet,
.v-menu__content.location-menu .v-list,
.v-menu__content.location-menu .v-picker,
.v-menu__content.location-menu .v-picker__title {
  border-radius: 0 !important;
}

</style>
